import React, { useState } from "react";
import { FaFacebook } from "react-icons/fa";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Row, Modal, ModalHeader, ModalBody, Input, Button } from "reactstrap";
import axios from "axios";

const SocialShare = () => {
  const selectedCard = useSelector((state) => state.bwvData.selectedService);
  const [modalOpen, setModalOpen] = useState(false);
  const [urlToCopy, setUrlToCopy] = useState("");

  const shareOnFacebook = () => {
    if (!selectedCard?.Id) {
      toast.error("Unable to share: Vendor details not available");
      return;
    }
    const urlToShare = encodeURIComponent(
      `${process.env.REACT_APP_URL}/home#/vendordetails/${selectedCard?.Id}`
    );
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${urlToShare}`,
      "_blank",
      "width=600,height=400"
    );
  };

  const copyToClipboard = async (text) => {
    // Try modern Clipboard API
    // if (navigator.clipboard && window.isSecureContext) {
    if (navigator.clipboard) {
      try {
        await navigator.clipboard.writeText(text);
        console.log("Clipboard API success");
        return true;
      } catch (err) {
        console.error("Clipboard API failed:", err.message);
      }
    }

    // Fallback for iOS or older browsers
    try {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.opacity = "0";
      textArea.contentEditable = true;
      textArea.readOnly = false;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      // iOS-specific range selection
      const range = document.createRange();
      range.selectNodeContents(textArea);
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);

      const success = document.execCommand("copy");
      document.body.removeChild(textArea);
      console.log("Fallback copy success:", success);
      return success;
    } catch (err) {
      console.error("Fallback copy failed:", err.message);
      return false;
    }
  };

  const showManualCopyModal = (url) => {
    setUrlToCopy(url);
    setModalOpen(true);
  };

  const handleManualCopy = async () => {
    const copied = await copyToClipboard(urlToCopy);
    if (copied) {
      toast.success("URL copied to clipboard!");
      setModalOpen(false);
    } else {
      toast.error("Failed to copy. Please select and copy the URL manually.");
      await navigator.clipboard.writeText("sample text");
    }
  };

  const shortenAndCopyUrl = async () => {
    if (!selectedCard?.Id) {
      toast.error("Unable to copy: Vendor details not available");
      return;
    }

    if (!process.env.REACT_APP_URL) {
      console.error("REACT_APP_URL is not defined in environment variables");
      toast.error("URL shortening unavailable: Base URL not configured");
      return;
    }

    if (!process.env.REACT_APP_BITLY_TOKEN) {
      console.error(
        "REACT_APP_BITLY_TOKEN is not defined in environment variables"
      );
      toast.error("URL shortening unavailable: Bitly token not configured");
      return;
    }

    const originalUrl = `${process.env.REACT_APP_URL}/?fbclid=socialLink#/vendordetails/${selectedCard.Id}`;

    try {
      const response = await axios.post(
        "https://api-ssl.bitly.com/v4/shorten",
        { long_url: originalUrl },
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_BITLY_TOKEN}`,
            "Content-Type": "application/json",
          },
        }
      );
      const shortenedUrl = response.data.link;
      const copied = await copyToClipboard(shortenedUrl);
      if (copied) {
        toast.success("Shortened URL copied to clipboard!");
      } else {
        showManualCopyModal(shortenedUrl);
      }
    } catch (err) {
      console.error(
        "Error shortening or copying URL:",
        err.response?.data || err.message
      );
      const errorMessage = err.response?.data?.message || err.message;
      toast.error("Failed to shorten URL: " + errorMessage);
      const copied = await copyToClipboard(originalUrl);
      if (copied) {
        toast.warn("Copied original URL instead (may not work in Instagram)");
      } else {
        showManualCopyModal(originalUrl);
      }
    }
  };

  return (
    <>
      <Row className="mt-1">
        <p>
          <b>Share</b>
        </p>
        <div>
          <ul className="m-0">
            <li>
              <button
                onClick={shareOnFacebook}
                style={{
                  fontSize: "22px",
                  border: "none",
                  background: "none",
                }}
                title="Share on Facebook"
              >
                <FaFacebook />
              </button>
              <button
                onClick={shortenAndCopyUrl}
                className="btn"
                style={{
                  marginLeft: "10px",
                }}
                title="Copy Shortened URL"
              >
                Copy URL
              </button>
            </li>
          </ul>
        </div>
      </Row>
      <Modal isOpen={modalOpen} toggle={() => setModalOpen(false)}>
        <ModalHeader toggle={() => setModalOpen(false)}>
          Copy URL Manually
        </ModalHeader>
        <ModalBody>
          <p>Unable to copy to clipboard. Select and copy the URL below:</p>
          <Input
            type="text"
            value={urlToCopy}
            readOnly
            onClick={(e) => e.target.select()}
            style={{ marginBottom: "10px" }}
          />
          <Button color="primary" onClick={handleManualCopy}>
            Try Copy Again
          </Button>
        </ModalBody>
      </Modal>
    </>
  );
};

export default SocialShare;
